module.exports = __webpack_public_path__ + "static/media/icon-modal-participant-info.f6a02efb.svg";